// extracted by mini-css-extract-plugin
export default {"tipWrapper":"Tip_tipWrapper__IHui3","TipHeader":"Tip_TipHeader__ukLvy"};